<div id="paginator" class="paginator-wrapper">
  <div class="row flex-item">

    <div class="col-sm-6 flex-item elements">
      <span>Pagina
        <input
          class="numericInput"
          type="number"
          value="1"
          [(ngModel)]="selectedPage"
          (keyup.enter)="setCurrentPage()">
        di {{ paginationDoc.getNPages() }}</span>
    </div>

    <div class="col-sm-6 paginator-actions flex-item-right">
      <div class="border-space"></div>
      <div class="left" (click)="decrement()"
        [class.disabled]="paginationDoc.getCurrentPage() <= 0"></div>
      <div class="right" (click)="increment()"
        [class.disabled]="((paginationDoc.getCurrentPage()+1) >= paginationDoc.getNPages())"
        style="margin-top: 2px;">
      </div>
    </div>
  </div>
</div>
